import * as React from 'react';
import {
  NODE_PARAGRAPH,
  render,
  MARK_LINK,
  NODE_UL,
} from 'storyblok-rich-text-react-renderer';
import FancyTitle from '../fancy-title';

import '../../css/custom.css';
import LinkResolver from '../../helpers/link-resolver';

export default function JobRow({ blok }) {
  return (
    <div
      className="mt-[40px] lg:mt-[60px] px-4 lg:px-16"
      key={`job-description-${blok._uid}`}
    >
      <FancyTitle
        text={blok.Title}
        tag="h3"
        fontSize="lg:text-4xl"
        marginBottom="mb-8"
      />

      <div className="job-detail">
        {render(blok.content, {
          markResolvers: {
            [MARK_LINK]: LinkResolver,
          },
          nodeResolvers: {
            // eslint-disable-next-line react/no-unstable-nested-components
            [NODE_UL]: (children) => (
              <ul className="lg:columns-2 lg:gap-x-16 lg:gap-y-1 list-disc list-outside ml-6 lg:ml-4 marker:text-latori-green marker:text-2xl lg:marker:text-3xl grid grid-cols-1 lg:grid-cols-2">
                {children}
              </ul>
            ),
            // eslint-disable-next-line react/no-unstable-nested-components
            [NODE_PARAGRAPH]: (children) => (
              <p className="m-auto first-of-type:mt-0 last-of-type:mb-0">
                {children}
              </p>
            ),
          },
        })}
      </div>

      {blok.button_text && blok.button_link?.url && (
        <a
          href={blok.button_link.url}
          target="_blank"
          rel="noreferrer"
          className="block mt-8 text-xl text-center uppercase  button-primary font-monospace lg:text-left lg:mt-16 w-fit"
        >
          {blok.button_text}
          <span> →</span>
        </a>
      )}
    </div>
  );
}
